<div class="flex items-center gap-2">
  <button
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="btn btn-filter flex w-fit flex-1 cursor-pointer items-center"
    type="button"
    (click)="toggleOverlay()"
  >
    <label class="flex items-center gap-2 px-1">
      <span class="font-bold">{{ "filters.period.label.period" | translate }}</span>
      <span>{{ getDisplayText() }}</span>
    </label>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  @if (hasSelectedDates()) {
    <button
      class="flex items-center text-xs text-primary-500 hover:text-primary-600"
      type="button"
      aria-label="Clear"
      (click)="clearFilter()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="toggleOverlay()"
>
  <mat-card>
    <mat-card-content>
      <div
        class="mb-4 flex cursor-pointer items-center gap-2"
        (click)="onModeToggleChange()"
      >
        <span>{{ "filters.period.label.singleDay" | translate }}</span>
        <mat-slide-toggle [checked]="isPeriodMode()"></mat-slide-toggle>
        <span>{{ "filters.period.label.periodRange" | translate }}</span>
      </div>

      <div class="mb-4 flex gap-4">
        <div class="flex flex-col">
          @if (isPeriodMode()) {
            <div>
              <mat-form-field class="w-full flex-1">
                <mat-label>
                  {{ isPeriodMode() ? ("filters.period.label.from" | translate) : ("filters.period.label.selectDay" | translate) }}
                </mat-label>
                <input
                  matInput
                  readonly
                  [value]="formatDateDisplay(tempDateFrom())"
                />
                <button
                  matIconSuffix
                  mat-icon-button
                  type="button"
                >
                  <mat-icon>calendar_month</mat-icon>
                </button>
              </mat-form-field>
            </div>
          }
          <mat-calendar
            class="w-64"
            [selected]="selectedRange()"
            [startAt]="getPreviousMonth()"
            [maxDate]="maxDateForFromCalendar()"
            (selectedChange)="onDateSelected($event)"
          ></mat-calendar>
        </div>
        <div class="flex flex-col">
          @if (isPeriodMode()) {
            <div>
              <mat-form-field class="w-full flex-1">
                <mat-label>{{ "filters.period.label.to" | translate }}</mat-label>
                <input
                  matInput
                  readonly
                  [value]="formatDateDisplay(tempDateTo())"
                />
                <button
                  matIconSuffix
                  mat-icon-button
                  type="button"
                >
                  <mat-icon>calendar_month</mat-icon>
                </button>
              </mat-form-field>
            </div>
          }
          <mat-calendar
            class="w-64"
            [selected]="selectedRange()"
            [startAt]="getCurrentMonth()"
            [minDate]="minDateForToCalendar()"
            (selectedChange)="onDateSelected($event, true)"
          ></mat-calendar>
        </div>
      </div>

      <div class="flex justify-end gap-2">
        <button
          type="button"
          class="btn"
          (click)="clearFilter()"
        >
          {{ "filters.period.action.resetFilter" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSubmit()"
        >
          {{ "filters.period.action.apply" | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
